/* eslint-disable no-unused-vars */
import { Table, Tag, Space, Spin } from 'antd';
import { memo } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import WithdrawPillTags from '../../components/pillTag/WithdrawPillTags';
import Paypal from '../../assets/images/paypal.svg';
import { ISOToMDY } from '../../utils/date';
import DokanIcons from '../../components/icon/DokanIcons';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

function WithdrawTable({
    withdrawList,
    withdrawStatus,
    currentStatus,
    openCancelModal,
    loader,
    handleWithdrawStatus,
}) {
    const columns = [
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (text) => <p className="font-bold">${text}</p>,
        },
        {
            title: 'Status',
            key: 'status',
            dataIndex: 'status',
            render: (status) => (
                <>
                    <WithdrawPillTags variant={status}>{status}</WithdrawPillTags>
                </>
            ),
        },
        {
            title: 'Method',
            dataIndex: 'method',
            key: 'method',
            render: (record) => (
                <>
                    <div className="flex items-center gap-2">
                        <div className="shadow-sm rounded-full w-12 h-12 bg-white">
                            <img src={Paypal} alt="svg" className="m-auto pt-3" />
                        </div>
                        <div>{record}</div>
                    </div>
                </>
            ),
        },
        {
            title: 'Date',
            dataIndex: 'created',
            key: 'created',
            render: (date) => <>{ISOToMDY(date)}</>,
        },

        {
            title: '',
            key: 'action',
            render: (record) => (
                <Space size="middle">
                    {record.status === 'pending' && (
                        // eslint-disable-next-line no-use-before-define
                        <button type="button" onClick={() => openCancelModal(record.id)}>
                            <DokanIcons icon="#check_cancel" />
                        </button>
                    )}
                </Space>
            ),
        },
    ];
    return (
        <>
            {/** start withdraw table */}
            <div className="mt-10 mb-8 flex justify-between">
                <div className="flex space-x-6 text-secondary">
                    {withdrawStatus.map((status) => (
                        <div
                            className={`cursor-pointer ${
                                status.value === currentStatus
                                    ? 'border-b-3px border-blue-dodger pb-5px text-primary'
                                    : ''
                            }`}
                            key={status.value}
                            role="button"
                            tabIndex="0"
                            onClick={() => handleWithdrawStatus(status.value)}
                        >
                            {status.title}
                        </div>
                    ))}

                    {/* <div
                        className="cursor-pointer border-b-3px border-blue-dodger pb-5px text-primary"
                        role="button"
                        tabIndex="0"
                        onClick={handleWithdrawStatus}
                    >
                        Approved Requests
                    </div>
                    <div
                        className="cursor-pointer"
                        role="button"
                        tabIndex="0"
                        onClick={handleWithdrawStatus}
                    >
                        Cancelled Requests
                    </div> */}
                </div>
                <div>&nbsp;</div>
            </div>

            {/** table body */}
            <div className="min-w-full">
                <Spin indicator={antIcon} spinning={loader}>
                    <Table
                        columns={columns}
                        dataSource={withdrawList}
                        pagination={false}
                        rowKey={(record) => record.id}
                    />
                </Spin>
            </div>
        </>
    );
}

export default WithdrawTable;
